// extracted by mini-css-extract-plugin
export default {"button":"JNqdn_"};